import React, { Component } from 'react';
import { Link } from 'gatsby';
import Slider from 'react-slick';
import { Image, Wrapper } from '.';
import './HomeSlider.scss';

class HomeSlider extends Component {
  goToSlide = (event, slideIndex) => {
    event.preventDefault();
    this.slider.slickGoTo(slideIndex);
  }

  goToNextSlide = (event) => {
    event.preventDefault();
    this.slider.slickNext();
  }

  goToPrevSlide = (event) => {
    event.preventDefault();
    this.slider.slickPrev();
  }

  render() {
    const {
      items,
      siteMetadata,
    } = this.props;
    const { storiesSlug } = siteMetadata;
    const settings = {
      dots: false,
      arrows: false,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      centerMode: true,
      centerPadding: '5%',
      responsive: [
        {
          breakpoint: 800,
          centerMode: true,
          centerPadding: '5%',
        },
      ],
    };
    return (
      <section className="home-slider">
        <Wrapper>
          <div className="slides">
            <Slider {...settings} ref={(slider) => { this.slider = slider; }}>
              {items.map((item, index) => {
                const { photo, story } = item;
                const { slug } = story;
                const storyData = story.document[0].data || {};
                const { storyTitle, location } = storyData;
                const path = `/${storiesSlug}/${slug}/`;
                return (
                  <div
                    key={index} // eslint-disable-line
                    className="slide"
                  >
                    <div className="image-container">
                      <Image image={photo} className="cover" />
                    </div>
                    <div className="label">
                      <div className="spacer" />
                      <div className="location">
                        {location.text}
                      </div>
                      <Link className="title" to={path}>
                        <div className="icon">
                          <svg viewBox="0 0 16 9" xmlns="http://www.w3.org/2000/svg">
                            <path d="M0 0v9l16-4.5z" fillRule="evenodd" />
                          </svg>
                        </div>
                        {storyTitle.text}
                      </Link>
                    </div>
                  </div>
                );
              })}
            </Slider>
            <div className="slider-buttons">
              <button
                className="slider-button slider-prev"
                type="button"
                aria-label="Go to previous slide"
                onClick={event => this.goToPrevSlide(event)}
              >
                <svg className="icon" viewBox="0 0 21 15" xmlns="http://www.w3.org/2000/svg">
                  <path d="M2.835 6.673h16.97a.85.85 0 0 1 0 1.7H2.877l4.89 5.193c.211.223.285.54.193.832a.864.864 0 0 1-.638.58.882.882 0 0 1-.833-.251L.23 8.08a.844.844 0 0 1-.228-.532.842.842 0 0 1 .228-.628L6.49.273a.882.882 0 0 1 .833-.252c.303.068.547.29.638.58a.841.841 0 0 1-.194.833L2.835 6.673z" fillRule="evenodd" />
                </svg>
              </button>
              <button
                className="slider-button slider-next"
                type="button"
                aria-label="Go to next slide"
                onClick={event => this.goToNextSlide(event)}
              >
                <svg className="icon" viewBox="0 0 21 15" xmlns="http://www.w3.org/2000/svg">
                  <path d="M18.165 6.673H1.195a.85.85 0 0 0 0 1.7h16.927l-4.89 5.193a.841.841 0 0 0-.193.832.864.864 0 0 0 .638.58.882.882 0 0 0 .833-.251l6.26-6.647a.844.844 0 0 0 .228-.532.842.842 0 0 0-.228-.628L14.51.273a.882.882 0 0 0-.833-.252.864.864 0 0 0-.638.58.841.841 0 0 0 .194.833l4.932 5.239z" fillRule="evenodd" />
                </svg>
              </button>
            </div>
          </div>
        </Wrapper>
      </section>
    );
  }
}

export default HomeSlider;
